import { useId, useMemo, useState } from 'react';
import { api } from '../api/apiClient';
import { IconCheck, IconKey } from './icons';

export default function AccountPasswordForm({ user, mustChange = false, onUserUpdated, onDone }) {
  const currentId = useId();
  const nextId = useId();
  const confirmId = useId();

  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);

  const displayName = useMemo(() => String(user?.display_name || '').trim() || String(user?.email || '').trim(), [user]);

  async function submit() {
    if (saving) return;
    setError('');
    setOk(false);
    const n = String(next || '');
    if (!n.trim()) {
      setError('Renseigne un nouveau mot de passe.');
      return;
    }
    if (n.trim().length < 12) {
      setError('12 caractères minimum.');
      return;
    }
    if (String(confirm || '') !== String(next || '')) {
      setError('La confirmation ne correspond pas.');
      return;
    }

    setSaving(true);
    try {
      const res = await api.accountPasswordUpdate({
        current_password: mustChange ? '' : current,
        new_password: n,
      });
      if (!res.ok) {
        setError(res.error || 'Enregistrement impossible');
        return;
      }
      if (res.user) onUserUpdated?.(res.user);
      setCurrent('');
      setNext('');
      setConfirm('');
      setOk(true);
      onDone?.();
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {mustChange ? (
        <div className="Notice">
          <span className="ButtonInline" style={{ gap: 10 }}>
            <IconKey />
            <span>
              {displayName ? <strong>{displayName}</strong> : null} — change ton mot de passe pour continuer.
            </span>
          </span>
        </div>
      ) : null}

      {!mustChange ? (
        <div className="Field">
          <label className="Label" htmlFor={currentId}>
            Mot de passe actuel
          </label>
          <input
            id={currentId}
            className="Input"
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            disabled={saving}
            autoComplete="current-password"
          />
        </div>
      ) : null}

      <div className="Field">
        <label className="Label" htmlFor={nextId}>
          Nouveau mot de passe
        </label>
        <input
          id={nextId}
          className="Input"
          type="password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          disabled={saving}
          autoComplete="new-password"
          placeholder="12 caractères minimum"
        />
      </div>

      <div className="Field">
        <label className="Label" htmlFor={confirmId}>
          Confirmer
        </label>
        <input
          id={confirmId}
          className="Input"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          disabled={saving}
          autoComplete="new-password"
        />
      </div>

      {error ? (
        <div className="Error" role="alert">
          {error}
        </div>
      ) : null}
      {ok ? (
        <div className="Notice" role="status" aria-live="polite">
          <span className="ButtonInline" style={{ gap: 10 }}>
            <IconCheck /> Mot de passe mis à jour.
          </span>
        </div>
      ) : null}

      <div className="Badges" style={{ justifyContent: 'flex-start' }}>
        <button type="button" className="Button" onClick={submit} disabled={saving}>
          {saving ? 'Enregistrement…' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
}

